import React, { useEffect, useRef, useState } from "react";

const STATS = [
  { value: 164, suffix: "+", label: "Patients Treated" },
  { value: 98, suffix: "%", label: "Success Rate" },
  { value: 2, suffix: "+", label: "Years Experience" },
  { value: 24, suffix: "×7", label: "Support" },
];

const Counter = ({ value, suffix }) => {
  const [n, setN] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const duration = 1400;
          const start = performance.now();
          const step = (t) => {
            const p = Math.min((t - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            setN(Math.floor(eased * value));
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      },
      { threshold: 0.5 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [value]);

  return (
    <span ref={ref} className="font-display text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900">
      {n}
      {suffix}
    </span>
  );
};

export const Stats = () => (
  <section
    data-testid="stats-section"
    className="py-16 sm:py-20 bg-gradient-to-b from-white to-slate-50/60"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="rounded-3xl bg-white border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.03)] p-8 sm:p-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {STATS.map((s) => (
            <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-center sm:text-left">
              <Counter value={s.value} suffix={s.suffix} />
              <p className="mt-2 text-sm text-slate-500 font-medium">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
